import script from "./RFPsRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./RFPsRequests.vue?vue&type=script&setup=true&lang=js"

import "./RFPsRequests.vue?vue&type=style&index=0&id=430f73bf&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430f73bf"]])

export default __exports__